import React, { memo, useContext, useEffect, useState, createContext, useRef, useMemo } from "react";
import { PlusOutlined, LeftCircleOutlined, RightCircleOutlined, DeleteOutlined, LoadingOutlined, FolderOpenOutlined, UploadOutlined, DownOutlined, ExclamationCircleFilled, MoreOutlined } from "@ant-design/icons";
import { Button, Image, Popconfirm, Upload, Modal, theme, Space, Dropdown, Input, Pagination } from "antd";
import ImageService from "services/image";
import FolderService from "services/folder";

import { useApp } from "contexts/app";
import { CSS } from "@dnd-kit/utilities";
import "./MultiImagePicker.css";
import { useAuth } from "contexts/auth";
import _, { forEach } from "lodash"
import ImagePickerContext from "./ImagePickerContext"
import FolderPicker from "./FolderPicker"
const { useToken } = theme;
const ROOT_FOLDER_ID = 'root';
const ROOT_FOLDER_NAME = 'Home';



const ImageModal = ({ open, onOk, onCancel }) => {
    const { folder, setFolder } = useContext(ImagePickerContext);
    const { value, maxPhotos, acceptedFormats, maxFileSize, onChange } = useContext(ImagePickerContext)
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef();
    const newFolderNameInputref = useRef();
    const [showCreateFolder, setShowCreateFolder] = useState(false);
    const [folderList, setFolderList] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const pageSize = 40;
    const { showNotify, modal, showLoading, prompt } = useApp();
    const [showFolderPicker, setShowFolderPicker] = useState(false)
    const [folderPickerOnSelectFn, setFolderPickerOnSelectFn] = useState({ callback: e => { console.log(e) } })
    const { token } = useToken();
    const initializedOnOpenRef = useRef(false);
    const latestLoadRequestRef = useRef(0);
    const loadData = async (folderLoad) => {
        const requestId = latestLoadRequestRef.current + 1;
        latestLoadRequestRef.current = requestId;
        setFiles([])
        const imageService = new ImageService();
        var lst = await imageService.list(folderLoad);
        if (requestId !== latestLoadRequestRef.current) {
            return;
        }
        setFiles(lst)
        setCurrentPage(1)
    }
    const delayLoad = useMemo(() => _.debounce(loadData, 500), []);
    useEffect(() => {
        if (open && !initializedOnOpenRef.current) {
            initializedOnOpenRef.current = true;
            setCurrentPage(1)
            setFiles([])
            if (folder !== ROOT_FOLDER_ID) {
                setFolder(ROOT_FOLDER_ID);
                return;
            }
        }

        if (open) {
            delayLoad(folder || ROOT_FOLDER_ID);
        } else {
            delayLoad.cancel();
            initializedOnOpenRef.current = false;
            setFiles([])
        }
    },
        [open, folder]);

    useEffect(() => {
        return () => {
            delayLoad.cancel();
        };
    }, [delayLoad]);


    useEffect(() => {

        loadFolder();

    }, []);



    const pagedFiles = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;
        return files.slice(start, end);
    }, [files, currentPage]);
    const loadFolder = async () => {
        const service = new FolderService();
        var lst = await service.list();
        setFolderList(lst);
    }

    const openFolder = (folderId) => {
        setFolder(folderId);
    }

    const currentFolder = useMemo(() => folderList.find(x => x.id == folder), [folderList, folder]);
    const childFolders = useMemo(() => folderList.filter(x => x.parent_id == folder), [folderList, folder]);
    const canGoParent = !!currentFolder && currentFolder.parent_id && currentFolder.parent_id !== currentFolder.id;
    const breadcrumbFolders = useMemo(() => {
        const chain = [];
        if (folder === ROOT_FOLDER_ID) {
            return [{ id: ROOT_FOLDER_ID, name: ROOT_FOLDER_NAME }];
        }

        let cursor = currentFolder;
        while (cursor) {
            chain.unshift(cursor);
            if (!cursor.parent_id || cursor.parent_id === ROOT_FOLDER_ID) {
                break;
            }
            cursor = folderList.find(x => x.id == cursor.parent_id);
        }

        return [{ id: ROOT_FOLDER_ID, name: ROOT_FOLDER_NAME }, ...chain];
    }, [folderList, currentFolder, folder]);

    const onClickImage = (img) => {
        var index = files.findIndex(x => x.id == img.id);
        var lstNew = [...files];
        lstNew[index].selected = !lstNew[index].selected;
        setFiles(lstNew)
    }
    const onSelectImage = () => {
        var selectedList = files.filter(x => x.selected).map(x => {
            var a = { ...x };
            delete a.selected;
            return a;
        })


        var newValue = _.concat((value ?? []), selectedList)
        onChange(newValue);
        onCancel();

    }

    const creaFileSize = async () => {
        const imageService = new ImageService();
        await imageService.createFileSize();
    }



    const uploadImage = async (file) => {
        const imageService = new ImageService();
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("folder", folder);

            const result = await imageService.upload(formData);
            return result;
        } catch (error) {
            error("File  was not uploaded. Please try again later");
            throw error;
        }
    };
    const onFilechange = async (e) => {
        setUploading(true);

        for (let index = 0; index < e.target.files.length; index++) {
            const element = e.target.files[index];
            await uploadImage(element)

        }
        setUploading(false);
        loadData(folder);
    }

    const items = [
        {
            label: 'Xoá',
            key: 'delete_images',
        },
        {
            label: 'Di chuyển',
            key: 'move_images',
        },

    ];



    const folderActions = [

        {
            label: 'Đổi tên',
            key: 'rename_folder',
        },
        {
            label: 'Di chuyển',
            key: 'move_folder',
        },
        {
            label: 'Xoá',
            key: 'delete_folder',
        },


    ];

    const onClick = ({ key }) => {

        switch (key) {
            case "delete_images":
                deleteImages();

                return;

            case "move_images":
                moveImages();

                return;

            default:
                break;
        }
    };

    const deleteImages = async () => {

        modal.confirm({
            title: 'Bạn có chắc chắn muốn xoá các hình này?',
            icon: <ExclamationCircleFilled />,
            // content: 'Some descriptions',
            onOk: async () => {
                var ids = files.filter(x => x.selected).map(x => x.id);
                const imageService = new ImageService();
                showLoading(true);
                await imageService.deleteList(ids);
                await loadData(folder);
                showLoading(false)
            },
            onCancel: () => {
                console.log('Cancel');
            },
        });
    }

    const moveImages = async () => {

        // modal.confirm({
        //     title: 'Bạn có chắc chắn muốn xoá các hình này?',
        //     icon: <ExclamationCircleFilled />,
        //     // content: 'Some descriptions',
        //     onOk: async () => {
        //         var ids = files.filter(x => x.selected).map(x => x.id);
        //         const imageService = new ImageService();
        //         showLoading(true);
        //         await imageService.deleteList(ids);
        //         await loadData(folder);
        //         showLoading(false)
        //     },
        //     onCancel: () => {
        //         console.log('Cancel');
        //     },
        // });


        setShowFolderPicker(true);
        setFolderPickerOnSelectFn({
            callback: async e => {
                var ids = files.filter(x => x.selected).map(x => x.id);

                const imageService = new ImageService();
                showLoading(true);
                await imageService.moveList(ids, e);
                await loadData(folder);
                showLoading(false)

            }
        })



    }


    const footer = () => {
        return (
            <div style={{ width: "100%", display: "flex" }}>
                <div >
                    <input type='file' accept="image/*" multiple onChange={onFilechange} ref={fileInputRef} style={{ display: "none" }} />
                    <Space>

                        {/* <Button icon={<UploadOutlined />} onClick={creaFileSize} loading={uploading}>Test</Button> */}
                    </Space>

                </div>
                <div style={{ flexGrow: 1 }}>


                    <Space>
                        <div style={{ display: "flex", gap: 4 }}>
                            {files.filter(x => x.selected).length > 0 &&
                                <Dropdown menu={{ items, onClick }}>
                                    <Button
                                        shape="circle"
                                        icon={<DownOutlined />}
                                    />
                                </Dropdown>
                            }
                            {files.filter(x => x.selected).map(x => {
                                return (
                                    <div onClick={e => onClickImage(x)}>
                                        <img src={x.url} style={{ width: 32, height: 32 }}></img>
                                    </div>
                                )
                            })}

                        </div>
                        <Button onClick={e => setShowCreateFolder(true)}>Tạo folder</Button>
                        <Button icon={<UploadOutlined />} onClick={e => fileInputRef.current.click()} loading={uploading}>Upload</Button>
                        <Button onClick={onSelectImage} type="primary">Ok</Button>
                    </Space>
                </div>
            </div>
        )
    }

    const createFolder = async () => {

        var name = newFolderNameInputref.current.input.value;
        // console.log(newFolderNameInputref.current.input,name)
        const service = new FolderService();
        var createdFolder = await service.create({ name: name, parent_id: folder })
        showNotify(`đã tạo folder ${name}`);
        setShowCreateFolder(false);
        loadFolder();
        setFolder(createdFolder.id)

    }

    const getTitle = () => {
        return "Chọn hình"
    }

    const folderMenuClick = ({ key }) => {
        if (key == "rename_folder") {
            renameFolder();
        }

        if (key == "delete_folder") {
            deleteFolder();
        }

        if (key == "move_folder") {
            moveFolder();
        }
        // alert(key)
    }

    const renameFolder = () => {
        prompt({
            title: "Đổi tên", label: "Nhập tên",
            onOk: async (text) => {
                const service = new FolderService();
                await service.update({ id: folder, name: text });

                loadFolder();
            }
        });
    }


    const deleteFolder = () => {
        modal.confirm({
            title: 'Bạn có chắc chắn muốn xoá folder ?',
            icon: <ExclamationCircleFilled />,
            // content: 'Some descriptions',
            onOk: async () => {
                var selectedFolder = folderList.find(x => x.id == folder);
                if (selectedFolder) {
                    const service = new FolderService();
                    await service.delete(folder);

                    await loadFolder();
                    setFolder(selectedFolder.parent_id || ROOT_FOLDER_ID)
                }

                // var ids = files.filter(x => x.selected).map(x => x.id);
                // const imageService = new ImageService();
                // showLoading(true);
                // await imageService.deleteList(ids);
                // await loadData(folder);
                // showLoading(false)
            },
            onCancel: () => {
                console.log('Cancel');
            },
        });
    }

    const moveFolder = () => {
        setShowFolderPicker(true);
        setFolderPickerOnSelectFn({
            callback: async e => {

                showLoading(true);
                const service = new FolderService();
                try {
                    await service.update({ id: folder, parent_id: e });
                } catch (error) {

                }

                await loadFolder();
                showLoading(false);

            }
        })

    }


    return (
        <>

            <Modal title={getTitle()} open={open} onCancel={onCancel} width={"75vw"} footer={footer} >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>

                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", minWidth: 0 }}>
                            {breadcrumbFolders.map((item, index) => (
                                <Space key={item.id} size={4}>
                                    <Button type="link" size="small" style={{ paddingInline: 0 }} onClick={() => openFolder(item.id)}>{item.name}</Button>
                                    {index < breadcrumbFolders.length - 1 ? <span>/</span> : null}
                                </Space>
                            ))}
                        </div>
                        {currentFolder && (
                            <Dropdown menu={{ onClick: folderMenuClick, items: folderActions }} trigger={['click']}>
                                <Button
                                    shape="circle"
                                    icon={<DownOutlined />}
                                />
                            </Dropdown>
                        )}
                    </div>

                    <div style={{ marginBottom: 12, display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {childFolders.map(item => (
                            <Button
                                key={item.id}
                                type="default"
                                icon={<FolderOpenOutlined />}
                                onClick={() => openFolder(item.id)}
                            >
                                {item.name}
                            </Button>
                        ))}
                    </div>

                    <div style={{ display: "flex", gap: 16, flexDirection: "row", flexWrap: "wrap", width: "100%", height: "50vh", overflow: "scroll" }}>
                        {pagedFiles.map(file => {
                            return (
                                <div key={file.id} onClick={e => onClickImage(file)} style={{ padding: 2, borderColor: file.selected ? token.colorPrimary : "transparent", borderWidth: 1, borderStyle: "solid", height: 100, width: 125 }}>
                                    <img

                                        preview={false}
                                        src={file.sm_url}
                                        style={{ objectFit: "cover", width: "100%", height: "100%" }}
                                    />
                                </div>
                            )
                        })}

                    </div>
                    <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={files.length}
                            onChange={page => setCurrentPage(page)}
                            showSizeChanger={false}
                            size="small"
                        />
                    </div>
                </div>


            </Modal>


            <Modal title="Tạo folder mới" open={showCreateFolder} onCancel={e => setShowCreateFolder(false)} onOk={createFolder}>
                <Input ref={newFolderNameInputref}></Input>

            </Modal>

            <FolderPicker open={showFolderPicker} onCancel={e => setShowFolderPicker(false)} onFolderSelected={e => {
                folderPickerOnSelectFn.callback(e);

            }}></FolderPicker>
        </>
    )
}










export default ImageModal;
